module.exports = "\r\n\r\n<join-finger-id></join-finger-id>\r\n\r\n<!-- <auth-successfully-completed></auth-successfully-completed> -->"